// 素材的启用过滤和排序规则。网页和构建期预渲染脚本共用，所以这里不能 import 其他模块。

export const enabledOnly = item => item.enabled !== false

const naturalCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base'
})

export const sortByOrder = (a, b) => {
  const orderA = a.sortOrder ?? 9999
  const orderB = b.sortOrder ?? 9999
  if (orderA !== orderB) return orderA - orderB
  return naturalCollator.compare(String(a.title || a.id), String(b.title || b.id))
}

export const materialSortTitle = item => String(item.title || item.titleEn || item.titleZh || item.id || '')
const startsWithNumber = item => /^\s*\d+/.test(materialSortTitle(item))

export function sortMaterialItems(items) {
  const sorted = [...items]
  if (sorted.length > 1 && sorted.every(startsWithNumber)) {
    return sorted.sort((a, b) => naturalCollator.compare(materialSortTitle(a), materialSortTitle(b)))
  }
  return sorted.sort(sortByOrder)
}
